import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StudentTestimonialComponent} from "./student-testimonial/student-testimonial.component";
import {NewsComponent} from "./news/news.component";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {ImageGalleryComponent} from "./image-gallery/image-gallery.component";

const routes: Routes = [
    {
        path: 'student-testimonial',
        component: StudentTestimonialComponent
    },
    {
        path: 'news',
        component: NewsComponent,
        data: {title: 'News'}
    },
    {
        path: 'upcoming-events',
        component : NewsComponent,
        data: {title: 'Upcoming Events'}
    },
    {
        path: 'announcements',
        component : NewsComponent,
        data: {title: 'Announcements'}
    },
    {
        path: 'media-coverage',
        component : NewsComponent,
        data: {title: 'Media Coverage'}
    },
    {
        path: 'fm-radio',
        component : NewsComponent,
        data: {title: 'Suno ARNI 90.8'}
    },
    {
        path: 'contact-us',
        component: ContactUsComponent,
    },
    {
        path: 'image-gallery',
        component: ImageGalleryComponent,
        data: {title: 'Image Gallery'},
    },
    {
        path: 'video-gallery',
        component: ImageGalleryComponent,
        data: {title: 'Video Gallery'},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class QuickLinksRoutingModule {
}
